import { useEffect, useState } from 'react';
import { api } from 'services/api';

type UseTotalCommission = {
  total: number;
  percent: number;
  loading: boolean;
};

export function useTotalCommissionFetch(): UseTotalCommission {
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    api
      .get('/dashboard/comissao')
      .then(response => {
        setTotal(response.data.value);
        setPercent(response.data.percent);
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return {
    total,
    percent,
    loading,
  };
}
